import { render } from "./show-controls.vue?vue&type=template&id=80862722&lang=pug"
import script from "./show-controls.vue?vue&type=script&setup=true&lang=js"
export * from "./show-controls.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__